// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const VibrationContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  flex-direction: column;
  display: flex;
  height: 100%;
`;

export const ThermometerContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
  padding: 0 0.5rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0;
  };
`;
